<template>
  <router-link :to="url" class="voice__item__wrap" target="_blank">
    <div class="voice__item" v-bind:class="`track--` + slideColor">
      <div class="voice__item__inner">
        <div class="voice__item__textbox">
          <p class="voice__item__text" v-html="textMessage" dir="ltr"></p>
        </div>
        <span class="voice__item__writer" dir="ltr"
          >@{{ this.writer }}さん</span
        >
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "slide-item",
  props: {
    url: {
      type: String,
    },
    textMessage: {
      type: String,
    },
    writer: {
      type: String,
    },
    slideColor: {
      type: String,
    },
  },
};
</script>
<style lang="scss">
@import "../assets/css/mixins";
.voice {
  &__item {
    display: block;
    max-width: 286px;
    width: 100%;
    text-align: left;
    margin: 0 auto;
    &.track {
      background-repeat: no-repeat;
      background-size: contain;
      &--red {
        @extend .track;
        background-image: url(../assets/images/bg-track_red.png);
        color: #d24646;
      }
      &--blue {
        @extend .track;
        background-image: url(../assets/images/bg-track_blue.png);
        color: #4c83a3;
      }
      &--green {
        @extend .track;
        background-image: url(../assets/images/bg-track_green.png);
        color: #589b37;
      }
      &--brown {
        @extend .track;
        background-image: url(../assets/images/bg-track_brown.png);
        color: #996940;
      }
    }
    &__wrap {
      padding: 10px;
    }
    &__inner {
      position: relative;
      padding-bottom: 55%;
      height: 100%;
    }
    &__textbox {
      font-size: 14px;
      line-height: 1.4;
      max-height: 4em;
      padding-right: 1em;
      position: absolute;
      left: 10.48951048951049%;
      top: 15%;
      width: calc(58.74125874125874% + 1em);
      overflow: hidden;
      @include mq-down {
        font-size: 12px;
        line-height: 1.4;
        left: 7%;
        top: 10%;
      }
      &::before {
        content: "…";
        display: block;
        position: absolute;
        right: 0;
        bottom: 0.25em;
        background-color: #fff;
      }
    }
    &__text {
      overflow: hidden;
      text-overflow: ellipsis;
      br {
        display: none;
      }
    }
    &__writer {
      font-size: 11px;
      position: absolute;
      bottom: 27.125%;
      right: 25%;
      @include mq-down {
        bottom: 26%;
        right: 21%;
      }
    }
  }
}
</style>
